export enum ButtonVariation {
  Primary = 'primary',
  PrimaryInversed = 'primary-inversed',
  Secondary = 'secondary',
  Danger = 'danger',
  Success = 'success',
  Link = 'link'
}
